<template>
  <el-card class="wrapperBoxList">
    <div class="wrapperBoxClick" @click="blockClickEvent">
      <el-col
        :xl="{ span: 10, offset: 0 }"
        :lg="{ span: 10, offset: 0 }"
        :md="{ span: 10, offset: 0 }"
        :sm="{ span: 10, offset: 0 }"
        :xs="{ span: 24, offset: 0 }"
        @click.native="handleClick"
      >
        <div
          class="video-card-container"
          element-loading-background="rgba(0, 0, 0, 0.8)"
        >
          <!-- Thumbnail regeneratinng button -->
          <el-tooltip
            v-if="videoInfo.status == 'ready' && hidenNewThumbnails == false"
            content="Click to generate other thumbnail"
          >
            <div class="video-card-thumb-overlay">
              <autorenew
                class="video-card-thumb-overlay__icon"
                @click="$emit('renewThumbnail')"
              />
            </div>
          </el-tooltip>
          <div class="video-card">
            <!-- Video thumbnail (or default) -->
            <thumbnail-image
              v-if="videoInfo.status == 'ready' || videoInfo.status == 'remote'"
              class="video-card-thumb videoThumb--active"
              :src="playPreview && hasSudioMode  !== 'studioAudioEdit' ? previewLink : thumbnailLinkVideoPhoto"
              :fallback="fallbackImage"
              alt="Video Preview"
              @mouseover="playPreview = true"
              @mouseleave="playPreview = false"
            />
            <thumbnail-image
              v-else
              class="video-card-thumb fallbackimg"
              :src="fallbackImage"
              alt="Video Preview"
            />
            <div
              v-if="videoInfo.status == 'ready' || videoInfo.status == 'remote'"
              class="video-card-info"
            >
              <div v-if="durationClip != null" class="video-card-info-param">
                <span class="video-card-info-label">Duration:</span>
                <span class="video-card-info-value">{{ durationLine }}</span>
              </div>
              <div v-if="streamDisplayName" class="video-card-info-param">
                <span class="video-card-info-label">Stream:</span>
                <span class="video-card-info-value">{{ streamDisplayName }}</span>
              </div>
              <div class="video-card-info-param">
                <span class="video-card-info-label">Title:</span>
                <span class="video-card-info-value">{{ titleStream }}</span>
              </div>
            </div>
            <div v-else class="video-card-info">
              <div class="video-card-info-param">
                <el-progress
                  :status="'success'"
                  :width="32"
                  :text-inside="true"
                  :percentage="this.progression"
                  :stroke-width="32"
                  :stroke-linecap="'square'"
                  class="videoProgressBar"
                />
                <span class="video-card-info-label">Stream:</span>
                <span class="video-card-info-value">{{ stream }}</span>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </div>
  </el-card>
</template>

<script>
import fallbackImage from "@/assets/images/empty.jpg";
import { mapState, mapGetters } from "vuex";
import { getDurationTimeline } from "@/utils/time.js";
import ThumbnailImage from "@/components/timeline/thumbnails/ThumbnailImage.vue";
import Autorenew from "vue-material-design-icons/Autorenew.vue";

export default {
  name: "SourcesList",
  components: {
    ThumbnailImage,
    Autorenew
  },
  props: {
    streamDisplayName: {
      type: String,
      default: ""
    },
    videoInfo: {
      type: Object,
      required: true
    },
    prosentageDragEndDrop: {
      type: Number,
      default: 0
    },
    thumbnailLink: {
      type: String,
      default: fallbackImage
    },
    /** is poster refreshing */
    isUpdatingThumbnail: {
      type: Boolean,
      default: false
    },
    durationClip: {
      type: Number,
      default: null
    },
    /** Wowza stream name */
    stream: {
      type: String,
      default: "No Stream"
    },
    selectedOption: {
      type: String,
      default: "audio"
    },
    isEditing: {
      type: Boolean,
      default: false
    },
    areEditingParamsValid: {
      type: String
    }
  },
  mounted() {
    if (this.videoInfo.status == "ready" || this.videoInfo.status == "remote") {
      this.$emit("videoSelected", this.videoInfo.id);
      this.$emit("changeCutMode");
    }
  },
  data() {
    return {
      fallbackImage,
      hidenNewThumbnails: true,
      playPreview: false,
      durationVideo: this.videoInfo.metadata.duration,
      thumbnailLinkVideo: this.videoInfo.thumbnailLink,
      titleStream: this.videoInfo.title,
      modalSourseList: true,
      cutMod: false,
      darkMode: false
    };
  },
  watch: {
    videoInfo() {
      this.durationVideo = this.videoInfo.metadata.duration;
      this.thumbnailLinkVideo = this.videoInfo.thumbnailLink;
      this.titleStream = this.videoInfo.title;
    },
    prosentageDragEndDrop() {
      this.videoInfo.progress = this.prosentageDragEndDrop;
    },
  },
  methods: {
    handleClick() {
      if (this.videoInfo.status == "ready" || this.videoInfo.status == "remote") {
        this.$emit("videoSelected", this.videoInfo.id);
      }
    },
    //Sending a click event and change to a mod cut
    blockClickEvent() {
      if (this.videoInfo.status == "ready" || this.videoInfo.status == "remote") {
        this.$emit("changeCutMode");
      }
    }
    // selectedOptionEvent(e) {
    //   this.$emit("selectedOptions", e);
    // },
    // handleEditings(e) {
    //   this.$emit("edits", e);
    // }
  },
  computed: {
    ...mapGetters(["hasSudioMode"]),
    ...mapState({
      thumbs: state => state.services.thumbs,
      timezone: state => state.timezone.timezone
    }),
    progression() {
      return this.videoInfo.progress;
    },

    // @vuese
    // Preview video source URL
    previewLink() {
      return this.videoInfo.previewLink
        ? `${this.videoInfo.storageUrl}/${this.videoInfo.previewLink}`
        : this.thumbnailLinkVideo;
    },
    thumbnailLinkVideoPhoto() {
      return `${this.thumbnailLinkVideo}`;
    },
    // @vuese
    // Duration time in format HH:mm:ss
    durationLine() {
      return getDurationTimeline(this.durationVideo);
    }
  }
};
</script>

<style>
.videoProgressBar .el-progress-bar__innerText {
  color: white;
}
.videoProgressBar .el-progress-bar .el-progress-bar__inner {
  text-align: center;
  height: 2rem;
}
.videoProgressBar .el-progress-bar .el-progress-bar__outer {
  height: 2rem;
}
</style>

<style scoped>
.wrapperBoxList {
  margin: 0 0px 5px 0;
  background: #303133;
}
.wrapperBoxClick {
  width: 100%;
  height: 100%;
}

.el-col-lg-10 {
  width: 100%;
}

/** progress bar */
.videoProgressBar {
  color: white;
  width: 100%;
  max-width: 200px;
  height: 2rem;
  margin: 0 0px 10px 0px;
  border-radius: 5px !important;
}

.fallbackimg {
  max-height: 140px;
}

/** thumbs */
.video-card-container {
  position: relative;
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
}

.video-card {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  overflow: hidden;
}

.video-card-thumb {
  /*
  width: 100%;
  height: 100%;
  position: relative;
  */
  height: 160px;
  width: 245px;
  overflow: hidden;
  flex-shrink: 0;
}

.video-card-thumb >>> img {
  display: block;
  object-fit: contain;
}

.video-card-thumb-overlay {
  position: absolute;
  z-index: var(--video-thumb-overlay-z);
  right: 0;
  top: 0;
  user-select: none;
  cursor: pointer;
}
.video-card-thumb-overlay__icon {
  margin-right: 4px;
  margin-top: 4px;
}
.video-card-thumb-overlay__icon svg {
  width: 1.5rem !important;
  height: 1.5rem !important;
}

.video-card-info {
  margin: 5px 0 10px 20px;
  flex-grow: 1;
  overflow: hidden;
}

.video-card-info-param {
  justify-self: start;
  text-align: start;
  margin-bottom: 4px;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.video-card-info-label {
  /* font-family: sans-serif; */
  /* width: 5rem; */
  margin-right: 5px;
  /* display: inline-block; */
  color: #ffffff;
}

.video-card-info-value {
  /* font-family: sans-serif; */
  font-weight: bold;
  margin-right: 5px;
  /* display: inline-block; */
  color: white;
  /* width: 130px; */
}

@media only screen and (max-width: 1500px) and (min-width: 1200px) {
  .video-card-thumb {
    height: 150px;
    width: 200px;
    overflow: hidden;
    flex-shrink: 0;
  }
}

@media only screen and (max-width: 1200px) and (min-width: 880px) {
  .video-card {
    flex-direction: column;
  }
  .video-card-thumb {
    max-width: 100%;
  }
  .video-card-info {
    margin: 15px 5px 5px;
    align-self: stretch;
    font-size: 80%;
  }
  .video-card-info-param {
    flex-direction: row;
  }
  .video-card-info-label {
    margin-right: 5px;
  }
}

/* extra */

.align-items {
  display: flex;
  align-items: baseline;
  padding: 10px;
  width: 100%;
  justify-content: flex-end;
}

.button-color-yellow {
  color: #e6a23c;
  background: #6b645a;
  border-color: #947950;
}
.button-color-yellow:hover {
  color: #6b645a;
  background: #e6a23c;
  border-color: #947950;
}

.button-color-green {
  color: #ffffff;
  background-color: #67c23a;
  border-color: #67c23a;
}

.button-color-green:hover {
  background: #65ae41;
  border-color: #65ae41;
  color: #ffffff;
}

.margin-text {
  /* margin: 0 150px 0 0; */
  position: absolute;
  left: 10px;
  top: 6px;
}

.style-button {
  padding: 0px 150px;
  font-size: 11px;
  border-radius: 4px;
  height: 30px;
  align-self: flex-end;
}

@media only screen and (max-width: 639px), only screen and (max-height: 740px) {
  .el-dialog.edit-form {
    height: 90vh;
  }
}

@media only screen and (max-width: 767px) {
  .video-mangomolo-controls {
    justify-content: center;
  }
}

@media only screen and (min-width: 1200px) {
  .material-design-icon__svg {
    height: 1rem !important;
    width: 1rem !important;
    margin-top: 2px !important;
  }
}

@media only screen and (min-width: 1920px) {
  /** progress bar */
  .videoProgressBar {
    height: 2.2rem;
    margin: 3px;
  }
  .material-design-icon__svg {
    height: 1rem !important;
    width: 1rem !important;
    margin-top: 2px !important;
  }
}
</style>
